var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');

var networkVariable = Object.create(Model);
  
networkVariable.name = 'Network Variable';
networkVariable.url = 'networkvariable';
networkVariable['@class'] = 'NetworkVariable';
networkVariable.parentClass = 'Resource';
networkVariable.fields = {
  parent: {
    hidden: true
  },
  name: {
    type: 'string',
    default: '',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  error: '',
  nvIndex: {
    type: 'number',
    validators: {
      presence: true,
    }
  },
  nvType: {
    type: 'string',
    validators: {}
  },
  nvSelector: {
    type: 'string',
    validators: {}
  },
  nvLength: {
    type: 'number',
    validators: {}
  },
  eesPath: {
    type: 'string',
    validators: {}
  },
  writable: {
    type: 'number',
    validators: {}
  },
  interval: {
    type: 'number',
    default: 0,
    validators: {
      numericality: {
        onlyInteger: true,
        greaterThan: -1
      }
    }
  }
};

networkVariable.initForm();

networkVariable.view = function () { 
  return  m('form', {role:'form'}, [
    networkVariable.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){networkVariable.form.name(ev.target.value)},
        value: networkVariable.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'index-input'}, 'NV Index'),
      m('input.form-control', {
        id:'index-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){networkVariable.form.nvIndex(ev.target.value)},
        value: networkVariable.form.nvIndex(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'unit-input'}, 'Type'),
      m('input.form-control', {
        id:'unit-input', 
        autocomplete: 'off',
        type:'text',
        onchange: function(ev){networkVariable.form.nvType(ev.target.value)},
        value: networkVariable.form.nvType(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'interval-input'}, 'NV Selector'),
      m('input.form-control', {
        id:'interval-input', 
        autocomplete: 'off',
        type:'text',
        onchange: function(ev){networkVariable.form.nvSelector(ev.target.value)},
        value: networkVariable.form.nvSelector(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'interval-input'}, 'NV Length'),
      m('input.form-control', {
        id:'interval-input', 
        autocomplete: 'off',
        type:'number', 
        onchange: function(ev){networkVariable.form.nvLength(ev.target.value)},
        value: networkVariable.form.nvLength(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'unit-input'}, 'EES Path'),
      m('input.form-control', {
        id:'unit-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){networkVariable.form.eesPath(ev.target.value)},
        value: networkVariable.form.eesPath(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'unit-input'}, 'Writable'),
      m('input.form-control', {
        id:'unit-input', 
        autocomplete: 'off',
        type:'number', 
        onchange: function(ev){networkVariable.form.writable(ev.target.value)},
        value: networkVariable.form.writable(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'interval-input'}, 'Interval'),
      m('input.form-control', {
        id:'interval-input', 
        autocomplete: 'off',
        type:'number', 
        onchange: function(ev){networkVariable.form.interval(ev.target.value)},
        value: networkVariable.form.interval(),
      })
    ])
  ])
}

module.exports = networkVariable;
